document.addEventListener("DOMContentLoaded", function(event) {

    const swiperIndexMakleriContainer = document.querySelector("[data-index-claim-slider]");
    if (!swiperIndexMakleriContainer) return;

    const swiperIndexMakleri = new Swiper(swiperIndexMakleriContainer, {
        slidesPerView: 1,
        loop: true,

        pagination: {
            el: '[data-index-claim-slider-pagination]',
            type: 'bullets',
            clickable: true,
        },

        navigation: {
            nextEl: '[data-index-claim-slider-next]',
        },
    });
});